import {FC} from 'react';

export const popup = {
  redirect: (Component?: FC) => ({
    type: 'UI_POPUP_REDIRECT' as const,
    Component
  })
}
